import { render, staticRenderFns } from "./lugares-instalacion.vue?vue&type=template&id=c2d145d2&scoped=true"
import script from "./lugares-instalacion.vue?vue&type=script&lang=js"
export * from "./lugares-instalacion.vue?vue&type=script&lang=js"
import style0 from "./lugares-instalacion.vue?vue&type=style&index=0&id=c2d145d2&prod&scoped=true&lang=css"
import style1 from "./lugares-instalacion.vue?vue&type=style&index=1&id=c2d145d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d145d2",
  null
  
)

export default component.exports